import React, { FC } from 'react';

const iconHorns = require('./icon_horns.svg');

export const IconHorns: FC = () => {
  return <img src={iconHorns} width={130} height={114} alt="icon_horns" />;
};

IconHorns.displayName = 'IconHorns';
